<template>
  <div ref="container" class="el-table-colmun-dict">
    <div class="title">基础用法</div>
    <el-table :data="tableData1">
      <el-table-column-dict align="center" maskType="name" prop="name" label="姓名" min-width="100">
        <template #header="{column, $index }">
          {{ $index + "," + column.label }}
        </template>
      </el-table-column-dict>
      <el-table-column-dict align="center" maskType="idCard" prop="idCard" label="身份证号" min-width="150"></el-table-column-dict>
      <el-table-column-dict align="center" maskType="mobile" prop="phone" label="手机号" min-width="100"></el-table-column-dict>
      <el-table-column-dict align="center" dictType="PERSON_TYPE" prop="type" label="人员类型" min-width="150"></el-table-column-dict>
      <el-table-column-dict align="center" dictTreeType="area" prop="areaCode" label="所属地区" min-width="150"></el-table-column-dict>
      <el-table-column-dict align="center" dateFormat="date" prop="birthday" label="出生日期" min-width="100"></el-table-column-dict>
      <el-table-column-dict maskType="address" prop="address" label="出生地" min-width="150"></el-table-column-dict>
      <el-table-column-dict align="center" :maskStart="4" :maskMiddle="5" :maskEnd="4" prop="code" label="统一信用代码" min-width="150"></el-table-column-dict>
    </el-table>

    <div class="title">设置默认值</div>
    <el-table :data="tableData2" >
      <el-table-column-dict defaultVal="张三" align="center" maskType="name" prop="name" label="姓名" min-width="100"></el-table-column-dict>
      <el-table-column-dict defaultVal="还没入户" align="center" maskType="idCard" prop="idCard" label="身份证号" min-width="150"></el-table-column-dict>
      <el-table-column-dict defaultVal="没手机" align="center" maskType="mobile" prop="phone" label="手机号" min-width="100"></el-table-column-dict>
      <el-table-column-dict defaultVal="不知道啥类型" align="center" dictType="PERSON_TYPE" prop="type" label="人员类型" min-width="150"></el-table-column-dict>
      <el-table-column-dict defaultVal="不知道啥地区" align="center" dictTreeType="area" prop="areaCode" label="所属地区" min-width="150"></el-table-column-dict>
      <el-table-column-dict defaultVal="无人知晓" align="center" dateFormat="date" prop="birthday" label="出生日期" min-width="100"></el-table-column-dict>
      <el-table-column-dict defaultVal="未知" maskType="address" prop="address" label="出生地" min-width="150"></el-table-column-dict>
      <el-table-column-dict defaultVal="这家伙没企业" align="center" :maskStart="4" :maskMiddle="5" :maskEnd="4" prop="code" label="统一信用代码" min-width="150"></el-table-column-dict>
    </el-table>

    <div class="title">其他用法</div>
    <el-table :data="tableData3">
      <el-table-column-dict defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type1" label="人员类型1" min-width="150"></el-table-column-dict>
      <el-table-column-dict defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type2" label="人员类2" min-width="300"></el-table-column-dict>
      <el-table-column-dict defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type3" label="人员类型3" min-width="450"></el-table-column-dict>
    </el-table>
    <el-table :data="tableData4">
      <el-table-column-dict :formatFun="formatFun" defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type1" label="人员类型1" min-width="150"></el-table-column-dict>
      <el-table-column-dict :formatFun="formatFun" defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type2" label="人员类2" min-width="300"></el-table-column-dict>
      <el-table-column-dict :formatFun="formatFun" defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type3" label="人员类型3" min-width="450"></el-table-column-dict>
    </el-table>
    <el-table :data="tableData5">
      <el-table-column-dict spacer="|" defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type1" label="人员类型1" min-width="150"></el-table-column-dict>
      <el-table-column-dict spacer="|" defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type2" label="人员类2" min-width="300"></el-table-column-dict>
      <el-table-column-dict spacer="|" defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type3" label="人员类型3" min-width="450"></el-table-column-dict>
    </el-table>
    <el-table :data="tableData5">
      <el-table-column-dict :formatFun="formatFun" spacer="|" defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type1" label="人员类型1" min-width="150"></el-table-column-dict>
      <el-table-column-dict :formatFun="formatFun" spacer="|" defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type2" label="人员类2" min-width="300"></el-table-column-dict>
      <el-table-column-dict :formatFun="formatFun" spacer="|" defaultValue="未知" align="center" dictType="PERSON_TYPE" prop="type3" label="人员类型3" min-width="450"></el-table-column-dict>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData1: [
        {
          name: "沈小布",
          idCard: "350624202201011314",
          phone: "18851314520",
          type: "001",
          birthday: "2022-01-01",
          address: "宁夏回族自治区闽宁镇金滩村520街道1314号",
          code: "12345678901234567890",
          areaCode: "350600"
        },
        {
          name: "邱哞哞",
          idCard: "350624202201015200",
          phone: "18855201314",
          type: "003",
          birthday: "2022-01-01",
          address: "宁夏回族自治区闽宁镇金滩村1314街道520号",
          code: "98765432109876543210",
          areaCode: "350500"
        }
      ],
      tableData2: [
        {
          name: "沈小布",
          idCard: "350624202201011314",
          phone: "18851314520",
          type: "001",
          birthday: "2022-01-01",
          address: "宁夏回族自治区闽宁镇金滩村520街道1314号",
          code: "12345678901234567890",
          areaCode: "350624"
        },
        {
          name: "",
          idCard: "",
          phone: "",
          type: "",
          birthday: "",
          address: "",
          areaCode: "",
          code: ""
        }
      ],
      tableData3: [
        {
          type1: "001",
          type2: "002,003",
          type3: "002,003,004"
        },
        {
          type1: "001",
          type2: "002,004",
          type3: "001,003,005"
        }
      ],
      tableData4: [
        {
          type1: ["001"],
          type2: ["002", "003"],
          type3: ["002", "003", "004"]
        },
        {
          type1: ["001"],
          type2: ["002", "004"],
          type3: ["001", "003", "005"]
        }
      ],
      tableData5: [
        {
          type1: "001",
          type2: "002|003",
          type3: "002|003|004"
        },
        {
          type1: "001",
          type2: "002|004",
          type3: "001|003|005"
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      const container = this.$refs.container
      const data = {"demoContainerHeight": container.scrollHeight + 20}
      window.parent.postMessage(data, "*")
    })
  },
  methods: {
    formatFun(arr) {
      //arr 是已有的字典数据 数组对象
      return arr.map(item => {
        return item.label
      }).join("/")
    }
  }
}
</script>

<style lang="less" scoped>
.el-table + .el-table {
  margin-top: 20px;
}
</style>